(function () {
  // セクションごとの初期化状態を管理（スクリプト読み込みは共通化）
  const controllers = new Map();
  let slickReady;

  // scriptタグの動的読み込み
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        reject(new Error('KVのスクリプトを読み込めませんでした'));
      };
      document.head.appendChild(script);
    });
  }

  // jQueryとSlickのスクリプトを取得（最大3回試行）
  function getSlick(root) {
    if (!slickReady) {
      slickReady = (async () => {
        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            if (!window.jQuery) await loadScript(root.dataset.jqueryUrl);
            if (!window.jQuery.fn.slick) await loadScript(root.dataset.slickUrl);
            if (!window.jQuery.fn.slick) throw new Error('KVの初期化を待機しています');
            return window.jQuery;
          } catch (error) {
            if (attempt === 2) throw error;
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
      })().catch(error => {
        slickReady = null;
        throw error;
      });
    }
    return slickReady;
  }

  // 表示中の性別に合致するKVか判定
  function isVisible(root) {
    const gender = root.dataset.gender;
    return !gender || gender === document.documentElement.dataset.storeGender;
  }

  // 指定スライドの画像・動画を読み込み（クローンスライド含む）
  function prepareSlide(root, index, priority = false) {
    root.querySelectorAll(`[data-kv-slide="${index}"]`).forEach(slide => {
      window.SanyoImages.load(slide, priority);
      const video = slide.querySelector('video');
      if (video && video.querySelector('source[data-src]')) {
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }
    });
  }

  // 表示対象のKVスライダーを初期化
  async function init(root) {
    if (!isVisible(root) || controllers.has(root)) return;
    const track = root.querySelector('.kv-slider');
    if (!track || !track.children.length) return;
    controllers.set(root, null);
    try {
      const $ = await getSlick(root);
      if (!root.isConnected) { controllers.delete(root); return; }
      const slider = $(track);
      const count = track.children.length;
      // 表示中スライドに応じた再生・自動送りの制御
      const update = () => {
        const current = slider.slick('slickCurrentSlide');
        // 非表示スライドの動画を停止（KV全体が非表示の場合は自動再生も停止）
        root.querySelectorAll('video').forEach(video => {
          if (!video.closest('.slick-current') || !isVisible(root)) video.pause();
        });
        if (!isVisible(root)) { slider.slick('slickPause'); return; }
        prepareSlide(root, current);
        const active = track.querySelector('.slick-current');
        const video = active && active.querySelector('video');
        // 動画再生中は自動送りを一時停止
        if (video) {
          slider.slick('slickPause');
          video.play().catch(() => {
            if (root.isConnected && isVisible(root) && video.closest('.slick-current')) slider.slick('slickPlay');
          });
        } else {
          slider.slick('slickPlay');
          const img = active && active.querySelector('img');
          // 現在スライドの読み込み完了後に次スライドの画像をプリロード
          const preloadNext = () => {
            requestAnimationFrame(() => {
              if (!isVisible(root) || slider.slick('slickCurrentSlide') !== current) return;
              const next = (current + 1) % count;
              const nextSlide = track.querySelector(`[data-kv-slide="${next}"]`);
              if (nextSlide && !nextSlide.querySelector('video')) prepareSlide(root, next);
            });
          };
          if (img && !img.complete) img.addEventListener('load', preloadNext, { once: true });
          else preloadNext();
        }
      };
      // 切り替え前に次スライドを読み込み、切り替え後に再生状態を更新
      slider.on('beforeChange', (event, slick, current, next) => prepareSlide(root, next));
      slider.on('afterChange', update);
      // Slickの初期化
      slider.slick({
        autoplay: false, infinite: true, slidesToShow: 1, slidesToScroll: 1,
        dots: true, centerMode: true, centerPadding: '0px', lazyLoad: false,
        pauseOnHover: false, pauseOnFocus: false, pauseOnDotsHover: false,
        speed: 500, fade: root.dataset.fade === 'true', cssEase: 'linear',
        arrows: root.dataset.arrows === 'true',
      });
      // 動画終了時に次スライドへ遷移（1枚のみの場合はループ再生）
      root.querySelectorAll('video').forEach(video => {
        video.addEventListener('ended', () => {
          if (!isVisible(root) || !video.closest('.slick-current')) return;
          if (count === 1) video.play().catch(() => {});
          else slider.slick('slickNext');
        });
      });
      controllers.set(root, { slider, update });
      update();
    } catch (error) {
      controllers.delete(root);
      console.error(error);
    }
  }

  // スライドの準備とスライダー位置の再計算
  function sync() {
    document.querySelectorAll('[data-top-kv]').forEach(root => {
      if (isVisible(root)) {
        prepareSlide(root, 0);
        init(root);
      }
      const controller = controllers.get(root);
      if (controller) {
        if (isVisible(root)) controller.slider.slick('setPosition');
        controller.update();
      }
    });
  }

  // 性別切り替え・テーマエディタでのセクション読み込み時に再同期
  document.addEventListener('sanyo:gender-change', sync);
  document.addEventListener('shopify:section:load', sync);
  // テーマエディタでのセクション削除時にSlickを破棄
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => {
      if (!event.target.contains(root)) return;
      if (controller) controller.slider.slick('unslick');
      controllers.delete(root);
    });
  });
  // リンク先未設定時のクリック無効化
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-top-kv] a');
    if (link && (!link.getAttribute('href') || link.getAttribute('href') === '#')) event.preventDefault();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();

